module.exports = __webpack_public_path__ + "img/wash.be5030ca.webp";